import List from "./List";
//import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

// export const PaymentCreate = Create;
export const PaymentList = List;
export const PaymentShow = Show;
export const PaymentEdit = Edit;
